import React, { useEffect } from 'react';
import Page from './Page';
import "./ExplorePage.scss";
import { SessionKeys, convertTimeFormat, getProcureInfo, redirectToPageUtil } from '../../utils/AppUtils';
import { useDispatch, useSelector } from 'react-redux';
import { getProductCategoriesData } from '../../redux/courses/actions';
import PillorsComp from '../components/PillorsComp';
import SectionHeader from '../components/SectionHeader/SectionHeader';
import ProductCardFinwell from '../components/card/ProductCardFinwell';
import Loader from '../../components/Loader/Loader';
import CateSubCatSelectionComp from '../components/CateSubCatSelectionComp';
import { t } from 'i18next';
import _ from 'lodash';
import { useNavigate, useLocation } from 'react-router-dom';
import NotFoundComponent from '../../components/NewDesign/NotFound/NotFoundComponent';
import ForYou from '../components/home/ForYou';
import ActionPathExploreComp from '../explore/ActionPathExploreComp';
import { getActiveHeader } from '../../redux/home/actions';
import CalculatorCard from '../components/card/CalculatorCard';

const ExplorePage = () => {

    const dispatch = useDispatch();
    const navigate = useNavigate();
    var productCategoriesDataCatRes = useSelector((state) => state.courses.productCategoriesData);

    const [isLoading, setIsLoading] = React.useState(false);
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);
    const initialPillar = searchParams.get("pillar_id") || "all";
    const initialCategory = searchParams.get("category_id") || [];
    const [activeTab, setActiveTab] = React.useState(initialPillar);
    const [pillarData, setPillarData] = React.useState([])
    const authBroker = useSelector((state) => state.auth.authBroker);
    const [courseData, setCourseData] = React.useState({});
    const [selectedCategory, setSelectedCategory] = React.useState(initialCategory);
    const [selectedSubcategory, setSelectedSubcategory] = React.useState([]);
    const [selectedContentType, setSelectedContentType] = React.useState([]);
    const [expandedCategoryId, setExpandedCategoryId] = React.useState(null);

    const [viewMoreActionPath, setViewMoreActionPath] = React.useState(false);
    const [viewMoreForYou, setViewMoreForYou] = React.useState(false);
    const [viewAllClicked, setViewAllCicked] = React.useState(false)
    const [categoryHidden, setCategoryHidden] = React.useState(false)
    const [moreContentTypeSelected, setMoreContentTypeSelected] = React.useState(false)
    const memoCategory = React.useMemo(() => [], []);
    const memoSubcategory = React.useMemo(() => [], []);
    
    useEffect(()=>{dispatch(getActiveHeader("explore"))},[])

    useEffect(() => {
        const currentParams = new URLSearchParams(location.search);
        const pillarIdFromUrl = currentParams.get("pillar_id") || "all";
        if (pillarIdFromUrl !== activeTab) {
            setViewAllCicked(false)
            setCategoryHidden(false)
            setViewMoreActionPath(false)
            setViewMoreForYou(false)
            setExpandedCategoryId(null)
            //setActiveTab(activeTab);
            currentParams.set("pillar_id", activeTab);
            navigate(`${location.pathname}?${currentParams.toString()}`);
            if(selectedContentType.length > 0 && selectedContentType[0].value === '10'){
            setSelectedContentType([])
           }
        }
    }, [location.search, activeTab]);
    useEffect(() => {
        const hasActionPath = selectedContentType.some(item => item.value === "10");
        const hasOtherTypes = selectedContentType.some(item => item.value !== "10");
        if(selectedContentType.length === 0){
            setViewMoreActionPath(false)
        }
        setCategoryHidden(hasActionPath);
        //setViewMoreActionPath(hasActionPath);

        if (hasActionPath && !hasOtherTypes) {
            setMoreContentTypeSelected(false);
        } else {
            setMoreContentTypeSelected(true);
        }
    }, [selectedContentType]);


    useEffect(()=>{
         callGetCategoriesData();
        console.log("getCategoriesData called")
    },[selectedCategory,selectedContentType, viewAllClicked])

    const callGetCategoriesData = () => {
        // if (selectedContentType.length === 0) {
        getCategoriesData();
        // } else if (
        //     (selectedContentType.length === 1 && selectedContentType[0].value !== "10") ||
        //     selectedContentType.length > 1
        // ) {
        //     getCategoriesData();
        // }
    }

    const getCategoriesData = () => {
        setIsLoading(true);
        const selectedCate = selectedCategory.map(v => v.value)
        let isActionPath = selectedContentType.some(item => item.value === "10");
        const selectedContent = selectedContentType
        .filter(item => item.value !== "10")
        .map(item => item.value);
        let reqObj = {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          category_id: expandedCategoryId ? [expandedCategoryId] : [...selectedCate],
          provider_id: "",
          search: "",
          sort: 1,
          page_size: 0,
          page: 1,
          popular_tab: false,
          popular_days: "",
          isAll:  false,
          language: "",
          brokerage_id:localStorage.getItem(SessionKeys.COMPANY_ID) || "",
          filter: 0,
          asset_id: selectedContent,
          pillar_id: activeTab === "all" ? "" : activeTab,
          is_action_path: isActionPath,
          page_type:"explore"
        };
    
        let moduleName = "getProductCategoriesData";
        
        dispatch(
          getProductCategoriesData({
            module: moduleName,
            postData: reqObj,
          })
        );
      };

    useEffect(() => {
        console.log("getCategoriesData called useEffect")
        if(activeTab === "all" && selectedCategory.length === 0){
            parseCategoryDatRes(productCategoriesDataCatRes);
        }else{
            parseCategoryDatResCat(productCategoriesDataCatRes);
        }
      }, [productCategoriesDataCatRes]);
    
      const parseCategoryDatRes = (productCategoriesDataCatRes) => {
        if (!_.isEmpty(productCategoriesDataCatRes)) {
            setIsLoading(false);

            if (productCategoriesDataCatRes.status === "success") {
            const categoryData = productCategoriesDataCatRes?.payload?.payload;
            const courseList = categoryData?.courseList || [];

            const pillarMap = new Map();

            courseList.forEach((course) => {
                const pillarKey = course.pillar_id || "";
                const pillarName = course.pillar_name || "";
                const pillarId = `${pillarKey}|${pillarName}`;

                if (!pillarKey || !pillarName) {
                    return;
                }
                // Tag and card building logic
                let tags = [];
                let btnTitle = t("Start course");

                if (course.provider?.provider_display_name) {
                tags.push(course.provider.provider_display_name);
                }
                tags.push("Course");

                if (course.lessons) {
                tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
                }
                if (course.duration) {
                tags.push(`${course.duration} ${course.durationUnit}`);
                }
                if (course.views) {
                tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
                }

                if (course.crs_progress > 0 && course.crs_progress < 100) {
                btnTitle = t("Resume course");
                } else if (course.crs_progress >= 100) {
                btnTitle = t("Revisit course");
                }

                const priceInfo = getProcureInfo(course.purchased_info);
                course.is_home = true;

                const cardData = {
                id: course?.courseId,
                is_like: course?.is_like ?? false,
                is_bookmark: course?.is_bookmark ?? false,
                dbId: course?.list_id,
                productType: course?.typ,
                productOrigin: course?.source,
                title: course?.name,
                logoURL: course?.provider?.provider_img || "",
                bannerURL: course?.imageURL,
                tagsArray: tags,
                description: course?.short_description,
                btnTitle: btnTitle,
                progress: course?.crs_progress,
                showLikeMenu: true,
                btnAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
                descAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch ),
                bannerAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
                footerLineComp: "",
                showHeader: true,
                showBody: !!course?.short_description,
                showFooter: true,
                showProgress: false,
                cardClassName: "",
                rightBtnIcon: "/images/arrow-right.svg",
                lefttBtnIcon: "",
                priceInfo,
                status: course?.crs_status,
                duration: convertTimeFormat(course?.duration, true),
                monitoring_name: course?.monitoring_name,
                course_categoryId: course?.course_categoryId,
                categoryName: course?.categoryName,
                asset_type: course?.product_type==="learningpath"?"Action Path":course.asset_name,
                monitoring_name: course.monitoring_name,
                asset_icon: course?.product_type==="learningpath"?"/images/finwell-img/extension.svg":course?.asset_icon,
                monitoring_icon: course?.monitoring_icon,
                isCoachPick:course?.is_coachpick
                };

                if (!pillarMap.has(pillarId)) {
                pillarMap.set(pillarId, []);
                }
                pillarMap.get(pillarId).push(cardData);
            });

            setPillarData(pillarMap);
            
            }
        }
    };
    const parseCategoryDatResCat = (productCategoriesDataCatRes) => {
        if (!_.isEmpty(productCategoriesDataCatRes)) {
            setIsLoading(false);
            if (productCategoriesDataCatRes.status === "success") {
            const categoryData = productCategoriesDataCatRes?.payload?.payload;
            const courseList = categoryData?.courseList || [];

            const pillarMap = new Map();

            courseList.forEach((course) => {
                const categoryKey = course?.categoryId[0] || "";
                const categoryName = course?.categoryName[0] || "";
                const pillarKey = course.pillar_id || "";
                const pillarName = course.pillar_name || "";
                const categoryId = (activeTab==="all" && selectedCategory?.length>0)?`${categoryKey}|${categoryName}`:`${categoryKey}|${categoryName}|${pillarKey}|${pillarName}`;

                if (!categoryKey || !categoryName) {
                    return;
                }
                // Tag and card building logic
                let tags = [];
                let btnTitle = t("Start course");

                if (course.provider?.provider_display_name) {
                tags.push(course.provider.provider_display_name);
                }
                tags.push("Course");

                if (course.lessons) {
                tags.push(`${course.lessons} Module${course.lessons > 1 ? "s" : ""}`);
                }
                if (course.duration) {
                tags.push(`${course.duration} ${course.durationUnit}`);
                }
                if (course.views) {
                tags.push(`${course.views} ${t("View")}${course.views > 1 ? "s" : ""}`);
                }

                if (course.crs_progress > 0 && course.crs_progress < 100) {
                btnTitle = t("Resume course");
                } else if (course.crs_progress >= 100) {
                btnTitle = t("Revisit course");
                }

                const priceInfo = getProcureInfo(course.purchased_info);
                course.is_home = true;

                const cardData = {
                id: course?.courseId,
                is_like: course?.is_like ?? false,
                is_bookmark: course?.is_bookmark ?? false,
                dbId: course?.list_id,
                productType: course?.typ,
                productOrigin: course?.source,
                title: course?.name,
                logoURL: course?.provider?.provider_img || "",
                bannerURL: course?.imageURL,
                tagsArray: tags,
                description: course?.short_description,
                btnTitle: btnTitle,
                progress: course?.crs_progress,
                showLikeMenu: true,
                btnAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
                descAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch ),
                bannerAction: () => redirectToPageUtil(course, navigate, authBroker, setCourseData, dispatch),
                footerLineComp: "",
                showHeader: true,
                showBody: !!course?.short_description,
                showFooter: true,
                showProgress: false,
                cardClassName: "",
                rightBtnIcon: "/images/arrow-right.svg",
                lefttBtnIcon: "",
                priceInfo,
                status: course?.crs_status,
                duration: convertTimeFormat(course?.duration, true),
                course_categoryId: course?.course_categoryId,
                categoryName: course?.categoryName,
                asset_type: course?.product_type==="learningpath"?"Action Path":course.asset_name,
                monitoring_name: course.monitoring_name,
                asset_icon: course?.product_type==="learningpath"?"/images/finwell-img/extension.svg":course?.asset_icon,
                monitoring_icon: course?.monitoring_icon,
                isCoachPick:course?.is_coachpick
                };

                if (!pillarMap.has(categoryId)) {
                pillarMap.set(categoryId, []);
                }
                pillarMap.get(categoryId).push(cardData);
            });
            setPillarData(pillarMap);
            
            }
        }
    };
    useEffect(()=> {
        setExpandedCategoryId(null)
        setSelectedCategory([])
    },[activeTab])

    const handleViewAll = (pillarId, category_id) => {
        let activeTabId = activeTab === "all"&&selectedCategory?.length>0?"all":_.cloneDeep(pillarId);
        searchParams.set("pillar_id", activeTabId);
        navigate(`${location.pathname}?${searchParams.toString()}`);
        setActiveTab(activeTabId);
        if(activeTab !== "all"){
            
            setExpandedCategoryId(category_id);
            setViewAllCicked(true)
        }else if(selectedCategory?.length>0){
            setExpandedCategoryId(pillarId);
            setViewAllCicked(true)
        }
    };
    const contentTypeActionPathSelected = (selectedContentType) => {
          return selectedContentType.some(item => item.value === "10");
    }

    return (
        <Page>
            <>
            <Loader start={isLoading} />
                <section className="explore-page">
                    <section className="calculator-head-box explore-head">
                        <h1 className='title-bannerpwc'>Explore</h1>
                        <p>Discover content and resources that empower you to make financial decisions.</p>
                    </section>
                    <div className="calculator-sec">
                        <PillorsComp activeTab={activeTab} setActiveTab={setActiveTab} setExpandedCategoryId={setExpandedCategoryId}/>
                        <div className="tab-content">
                            <CateSubCatSelectionComp setSelectedCategory={setSelectedCategory} setSelectedSubcategory={setSelectedSubcategory} selectedCategory={selectedCategory} selectedSubcategory={selectedSubcategory} selectedContentType={selectedContentType} setSelectedContentType={setSelectedContentType} showContentType = {true} showSubCate={false} showCategory={true}/>
                            {pillarData.size === 0 ? (
                            <NotFoundComponent showMsg={true} />
                            ) : 
                                <>
                                { !viewAllClicked && <ForYou from = {"explore"} viewMoreForYou={viewMoreForYou} setViewMoreForYou={setViewMoreForYou} selectedContentType={selectedContentType}/>}
                                
                                {!viewMoreForYou && selectedCategory.length === 0 && selectedContentType?.length ===0 && <ActionPathExploreComp selectedCategory={selectedCategory} activeTab={activeTab} viewMoreActionPath={viewMoreActionPath} setViewMoreActionPath={setViewMoreActionPath} categoryHidden={categoryHidden} setCategoryHidden={setCategoryHidden} selectedContentType={selectedContentType} setSelectedContentType={setSelectedContentType}/>}
                              
                                {(!viewMoreForYou) && Array.from(pillarData.entries()).map(([key, cards]) => {
                                    const [pillarId, pillarName, orgPillarId] = key.split('|');
                                    const isExpanded = expandedCategoryId === pillarId;
                                    const showViewAll = !isExpanded && cards.length > 4;

                                    const visibleCards = isExpanded ? cards : cards.slice(0, 4);
                                    console.log("cards", key)
                                    return (
                                        <SectionHeader
                                            key={pillarId}
                                            title={pillarName}
                                            subtitle=""
                                            onViewAll={() => handleViewAll(orgPillarId ? orgPillarId : pillarId, pillarId)}
                                            pillarId={pillarId}
                                            showViewAll={showViewAll}
                                        >
                                            {visibleCards.map((card, i) => {
                                                return (
                                                <div key={`course-${i + 1}`}>
                                                        <ProductCardFinwell {...card} />
                                                   </div>
                                               
                                            )})}
                                        </SectionHeader>
                                    );
                                })}
                                {!categoryHidden && selectedCategory.length === 0 &&
                                selectedContentType.length === 0 && !viewMoreForYou &&
                                <SectionHeader
                                key={'calc'}
                                title={'Calculators'}
                                subtitle={"Continue exploring tools that help you make smarter money moves."}
                                onViewAll={() => navigate('/calc')}
                                pillarId={'calc-id'}
                                showViewAll={true}
                            >
                                  <CalculatorCard selectedCategory={memoCategory} selectedSubcategory={memoSubcategory}
                                    activeTab={''} setIsLoading={() => { }} from={'explore'}
                                />
                            </SectionHeader>
                            }
                            </>}
                        </div>
                    </div>
                </section>
            </>
        </Page>
    );
};

export default ExplorePage;